import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";

function AssignClassForm() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [clearRows, setClearRows] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      centerId: "",
    },
  });

  const [classesData, setClassesData] = useState([]);
  const [selectedCenterIds, setSelectedCenterIds] = useState(
    savedCenterId || null
  );
  const [selectedClassIds, setSelectedClassIds] = useState([]);
  const [centersData, setCentersData] = useState([]);
  const [classSelectError, setClassSelectError] = useState("");

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCentersData(response);
        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
            getAllClassesList(selectedCenter.id);
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
  }, [setValue, triggerRerender, savedCenterId]);

  const getAllClassesList = async (centerId) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Class/AssignedClasssesToCenter?centerId=${centerId}&&organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setClassesData(response);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      omit: true,
    },
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      // width: "60px",
    },
    // {
    //   name: "Sr No.",
    //   selector: (row) => row.id,
    //   sortable: true,
    // },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
  ];

  // const onCenterSelect = (centerIds) => {
  //   const valuesArray = centerIds.map((center) => ({
  //     id: center.value,
  //   }));
  //   setSelectedCenterIds(valuesArray);
  // };

  const onCenterSelect = (selectedCenter) => {
    setSelectedCenterIds(selectedCenter.value);
  };

  const handleRowSelected = (state) => {
    const selectedRows = state.selectedRows.map((row) => ({
      id: row.id,
      status: true,
    }));

    const unselectedRows = classesData
      .filter(
        (row) => !state.selectedRows.some((selected) => selected.id === row.id)
      )
      .map((row) => ({
        id: row.id,
        status: false,
      }));
    // Combine selected and unselected rows
    setSelectedClassIds([...selectedRows, ...unselectedRows]);
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    if (selectedClassIds.length === 0) {
      setClassSelectError("Please select at least one class.");
      return;
    } else {
      setClassSelectError("");
    }

    const formData = {
      createdBy: localStorage.getItem("userId"),
      centerId: selectedCenterIds,
      classIds: selectedClassIds,
    };

    try {
      const response = await post("Class/SaveCenterClasses", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.isSuccess) {
        toast.success("Success!");
        getAllClassesList(selectedCenterIds);
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assign Classes to Center</h2>
      </div>

      <form
        className="row g-3 new-form-style"
        onSubmit={handleSubmit(saveData)}
      >
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Center<span className="text-danger fs-9">*</span>
                  </label>

                  {/* <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        isDisabled={!!savedCenterId}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`centerId`, null);
                          } else {
                            setValue(
                              `centerId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            onCenterSelect(selectedOption);
                            getAllClassesList(selectedOption.value);
                          }
                          trigger(`centerId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable={!savedCenterId}
                        // isMulti
                      />
                    )}
                  /> */}

                  <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        isDisabled={savedCenterId !== "0"}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`centerId`, null);
                          } else {
                            setValue(
                              `centerId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            onCenterSelect(selectedOption);
                            getAllClassesList(selectedOption.value);
                          }
                          trigger(`centerId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable={
                          savedCenterId !== null && savedCenterId !== 0
                        }
                      />
                    )}
                  />

                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label">
                    Classes<span className="text-danger fs-9">*</span>
                  </label>

                  <small className="text-danger">{classSelectError}</small>

                  <DataTable
                    columns={columns}
                    data={classesData}
                    pagination
                    dense
                    customStyles={customTableStyles}
                    highlightOnHover={true}
                    // pointerOnHover={true}
                    selectableRows
                    onSelectedRowsChange={handleRowSelected}
                    onChangePage={setCurrentPage}
                    onChangeRowsPerPage={setRowsPerPage}
                    clearSelectedRows={clearRows}
                    selectableRowSelected={useMemo(
                      () => (row) => row.status === true, // Automatically check rows with status 1
                      [classesData]
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default AssignClassForm;
